export default __webpack_public_path__ + "static/advent-2f084c904f013f83e07406982e5fad42.png";